import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const settingsRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-virtualagent-settings',
	exact: true,
	path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/settings/:tab(basic|channels)?',
};
